import React, {useState, useRef, useEffect, useContext } from "react";
import ReactPlayer from "react-player" 
import config from '../utils/config'
import { Box } from '@mui/material';
import e from "cors";
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '../styles/theme'
import AppContext from "../utils/app-context.js";

const VIDEOS = [
  'https://www.youtube.com/watch?v=C0DPdy98e4c',
  'https://www.youtube.com/watch?v=Mxesac55Puo'
]

const last_take_stream_url = "https://storage.googleapis.com/v0zebra-dev.appspot.com/p/st/2EIOnw7CX3kSRUROpD3V/sh/XIK53BUHTq0KyuBoO8pM8/ta/765f7064-b067-40fe-bc6e-82901d872d52/q/2022-04-26T18_23_25_556Z-1.mp4"

const outro_url = config.storage_api + '/resource/vid/outro_1080.m4v'

export default function ZebraPlayer(props) {
  const { state } = useContext(AppContext);
  const video_urls = props.use_outro ? [ ...props.video_urls, outro_url] : props.video_urls;
  const onPlay = props.onPlay ? props.onPlay : () => {}
  const onPause = props.onPause ? props.onPause : () => {}
  const onEnded = props.onEnded ? props.onEnded : () => {}
  const onStart = props.onStart ? props.onStart : () => {}
  const playerStyles = props.playerStyles ? props.playerStyles : {}
  const volume = props.volume ? props.volume : 0
  const muted = props.muted === false ? props.muted : true
  const num_clips = video_urls.length
  const trim = props.trim;
  //const rPlayer = useRef(null);
  const [index, setPlayIndex] = useState(0);
  const [playing, setPlaying] = useState(false);
  const selectedPreview = props.selectedPreview;
  const forwardRef = props.forwardRef ? props.forwardRef : useRef(null);
  //const [ playState, setPlayState ] = useState(false);
  const medScreen = (useMediaQuery(theme.breakpoints.down("md"))) ? true : false
  const smallScreen = (useMediaQuery(theme.breakpoints.down("sm"))) ? true : false
  
  // good-enough-for-now buffering 
  // so that the next clip can load while the current plays
  const [lookAhead, setLookAhead] = useState(true); 

  const lookAheadindex = (index < (num_clips - 1)) ? index + 1 : 0

  const wrapStyles = {
    //paddingTop: !selectedPreview ? "56.25%" : medScreen ? "56.25%" : "80vh", 
    //position:'relative'
    width: '100%', 
    height: '100%',
  }

  const nextVideo = () => {
    if (index < (num_clips - 1)){
    	setPlayIndex(index + 1)
    }
    else {
      onEnded();
      if(trim && trim[index]?.length) {
        forwardRef.current?.seekTo(trim[index][0] / 1000, 'seconds')
      }
      setPlayIndex(0)
      //rPlayer.current?.seekTo(0)
      setPlaying(false)
    }
  }

  useEffect(() => {
    if(trim && trim[index]?.length) {
      forwardRef.current?.seekTo(trim[index][0] / 1000, 'seconds')
    }
  }, [index]);

  const startVideo = () => {
    setPlaying(true)
  }

  const stopVideo = () => {
    setPlaying(false)
    if(trim && trim[index]?.length) {
      forwardRef.current?.seekTo(trim[index][0] / 1000, 'seconds')
    }
  }

  const stopPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  const readyVideo = () => {
    if(props.playing) {
      startVideo()
    }
  }

  const handleProgress = (state) => {
    if(trim?.length && trim[index]?.length) {
      if(state.playedSeconds >= trim[index][1] / 1000) {
        stopVideo();
        nextVideo();
      }
    }
  }

  //if(playing) setPlaying(true)
  if(props.playing && !playing) setPlaying(true)
  else if(!props.playing && playing) setPlaying(false)

  if(video_urls[index] == null) return <Box></Box>
  
  return (
    <>
    {/*<Box sx={wrapStyles}>
      <Box sx={{ /*position:'absolute', top:0,*/ /*width:'100%', height:'auto' , maxWidth:'1500px', *display:"flex", flex:1,* height: '100%', maxHeight: props.maxHeight || '100%', aspectRatio: state.stories.activeStory.is_vertical ? '9/16' : '16/9', margin:'0 auto' }}>
        */}
        <ReactPlayer   
          ref={forwardRef}       
          url={[video_urls[index]]}
          className='react_player'
          controls={props.controls}
          allowFullScreen={false}
          light={props.light}
          playsinline={true}
          playIcon={<span></span>}
          onProgress={handleProgress}
          playing={playing}
          onPlay={(e) => { startVideo(); onPlay(e) }}
          onPause={(e) => { stopVideo(); onPause(e) }}
          muted={muted}
          volume={volume}
          /*width='100%'
          height="auto" //{!selectedPreview ? "100%" : medScreen ? "100%" : "80vh"}*/
          width={props.width ? props.width : '100%'}
          height={props.height ? props.height : '100%'}
          loop={props.loop != undefined ? props.loop : true}
          onEnded={(e) => {nextVideo(); onEnded(e);}}
          onReady={readyVideo}
          onStart={() => {startVideo(); onStart();}}
          onClick={(e)=>{props.onClick != undefined ? props.onClick(e) : null}/*startVideo*/}
          style={playerStyles}
          /*onMouseOver={startVideo}
          onHover={startVideo}
          onMouseOut={stopVideo}*/
        />
        {lookAhead && <Box sx={{ position:'absolute', top:'0', zIndex:'-1' }}><ReactPlayer
          url={[video_urls[lookAheadindex]]}
          className='react_player'
          controls={false}
          allowFullScreen={false}
          light={false}
          volume={0}
          width='0%'
          height='1%'
          playIcon={false}
          playing={false}
          onEnded={nextVideo}
          onStart={startVideo}
        /></Box>}
      {/*</Box>
    </Box>*/}
    </>
  )
}